/*
 * ml-quick-sheet : tiroir bas d'ajout rapide facon Meshki (Well Worn London, 2026-09-12).
 * Un « + » sur une carte (cross-sell du panier pour l'instant) ouvre un panneau
 * qui monte du bas avec le nom, le prix, les coloris (pastilles) et les tailles.
 * Choix couleur -> tailles mises a jour ; choix taille -> bouton « Add to bag »
 * actif ; ajout via le meme flux que le theme (fetchConfig + cart.renderContents).
 * Les donnees viennent de /products/<handle>.js, chargees a l'ouverture.
 */
(function () {
  if (window.__mlQuickSheetReady) return;
  window.__mlQuickSheetReady = true;

  var sheet, panel, overlay, elTitle, elPrice, elColorRow, elColorName, elSwatches, elSizeLabel, elSizes, elCta;
  var product = null, colorIdx = -1, sizeIdx = -1, selColor = null, selSize = null, selVariant = null, loading = false;

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return '£' + v.replace(/\.00$/, '');
  }

  function cache() {
    sheet = document.getElementById('MlQuickSheetRoot');
    if (!sheet) return false;
    panel = sheet.querySelector('.ml-sheet__panel');
    overlay = sheet.querySelector('.ml-sheet__overlay');
    elTitle = sheet.querySelector('.ml-sheet__title');
    elPrice = sheet.querySelector('.ml-sheet__price');
    elColorRow = sheet.querySelector('.ml-sheet__colors');
    elColorName = sheet.querySelector('.ml-sheet__color-name');
    elSwatches = sheet.querySelector('.ml-sheet__swatches');
    elSizeLabel = sheet.querySelector('.ml-sheet__size-label');
    elSizes = sheet.querySelector('.ml-sheet__sizes');
    elCta = sheet.querySelector('.ml-sheet__cta');
    return true;
  }

  function variantOf(color, size) {
    return product.variants.find(function (v) {
      var okC = colorIdx === -1 || v.options[colorIdx] === color;
      var okS = sizeIdx === -1 || v.options[sizeIdx] === size;
      return okC && okS;
    });
  }

  function firstImageForColor(color) {
    var v = product.variants.find(function (x) { return x.options[colorIdx] === color && x.featured_image; });
    if (v && v.featured_image) return v.featured_image.src;
    return product.featured_image || (product.images && product.images[0]) || '';
  }

  function shortSize(label) {
    return label.indexOf('/') > -1 ? label.split('/').pop().trim() : label;
  }

  function open(handle) {
    if (!cache()) return;
    resetTransient();
    elTitle.textContent = '';
    elPrice.textContent = '';
    elSwatches.innerHTML = '';
    elSizes.innerHTML = '';
    sheet.hidden = false;
    document.documentElement.classList.add('ml-sheet-open');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });

    fetch('/products/' + handle + '.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        product = p;
        colorIdx = p.options.findIndex(function (o) { var n = (o.name || o).toLowerCase(); return n.indexOf('colour') > -1 || n.indexOf('color') > -1; });
        sizeIdx = p.options.findIndex(function (o) { var n = (o.name || o).toLowerCase(); return n.indexOf('size') > -1 || n.indexOf('taille') > -1; });
        build();
      })
      .catch(function () { elTitle.textContent = 'Sorry, unavailable'; });
  }

  function build() {
    elTitle.textContent = product.title.split(' ')[0];
    elPrice.textContent = money(product.price);

    // couleurs
    if (colorIdx > -1) {
      var colors = [];
      product.variants.forEach(function (v) { if (colors.indexOf(v.options[colorIdx]) === -1) colors.push(v.options[colorIdx]); });
      elColorRow.hidden = colors.length < 2 && colorIdx === -1;
      elColorRow.hidden = false;
      elSwatches.innerHTML = '';
      colors.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ml-sheet__swatch';
        b.setAttribute('aria-label', c);
        var img = firstImageForColor(c);
        if (img) {
          img = String(img).split(/[?&]width=/)[0];
          var sep = img.indexOf('?') > -1 ? '&' : '?';
          b.style.backgroundImage = "url('" + img + sep + "width=120')";
        }
        b.addEventListener('click', function () { selectColor(c); });
        elSwatches.appendChild(b);
      });
      // couleur par defaut : la premiere avec une variante dispo
      var def = colors.find(function (c) { return product.variants.some(function (v) { return v.options[colorIdx] === c && v.available; }); }) || colors[0];
      selectColor(def);
    } else {
      elColorRow.hidden = true;
      renderSizes();
    }

    // pas de taille : ajout direct de la variante (couleur choisie) ou variante unique
    if (sizeIdx === -1) {
      elSizeLabel.hidden = true;
      elSizes.hidden = true;
    } else {
      elSizeLabel.hidden = false;
      elSizes.hidden = false;
    }
    updateCta();
  }

  function selectColor(c) {
    selColor = c;
    selSize = null;
    selVariant = null;
    if (elColorName) elColorName.textContent = c;
    Array.prototype.forEach.call(elSwatches.children, function (b) {
      b.classList.toggle('is-active', b.getAttribute('aria-label') === c);
    });
    var img = firstImageForColor(c);
    renderSizes();
    updateCta();
  }

  function renderSizes() {
    if (sizeIdx === -1) {
      // sans taille : la variante est celle de la couleur (ou l'unique)
      selVariant = colorIdx > -1 ? variantOf(selColor, null) : product.variants[0];
      return;
    }
    var sizes = [];
    product.variants.forEach(function (v) { if (sizes.indexOf(v.options[sizeIdx]) === -1) sizes.push(v.options[sizeIdx]); });
    elSizes.innerHTML = '';
    sizes.forEach(function (s) {
      var v = variantOf(colorIdx > -1 ? selColor : null, s);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ml-sheet__size' + (v && v.available ? '' : ' is-unavailable');
      b.textContent = shortSize(s);
      b.setAttribute('aria-label', s);
      if (!v || !v.available) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); }
      b.addEventListener('click', function () { selectSize(s, b); });
      elSizes.appendChild(b);
    });
  }

  function selectSize(s, btn) {
    selSize = s;
    selVariant = variantOf(colorIdx > -1 ? selColor : null, s);
    Array.prototype.forEach.call(elSizes.children, function (b) { b.classList.toggle('is-active', b === btn); });
    if (selVariant) elPrice.textContent = money(selVariant.price);
    updateCta();
  }

  function updateCta() {
    var ready = false;
    if (sizeIdx === -1) {
      ready = !!(selVariant && selVariant.available);
      elCta.textContent = ready ? 'Add to bag' : 'Unavailable';
    } else if (!selSize) {
      elCta.textContent = 'Select size';
    } else if (selVariant && selVariant.available) {
      ready = true;
      elCta.textContent = 'Add to bag';
    } else {
      elCta.textContent = 'Unavailable';
    }
    elCta.disabled = !ready || loading;
    elCta.classList.toggle('is-ready', ready && !loading);
  }

  function addToCart() {
    if (!selVariant || loading) return;
    loading = true;
    elCta.classList.add('is-loading');
    elCta.textContent = 'Adding…';
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var fd = new FormData();
    fd.append('id', selVariant.id);
    fd.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    config.body = fd;
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { elCta.textContent = res.description || 'Unavailable'; return; }
        if (cart) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          if (typeof cart.renderContents === 'function') cart.renderContents(res);
        }
        close();
      })
      .catch(function () { elCta.textContent = 'Try again'; })
      .finally(function () { loading = false; elCta.classList.remove('is-loading'); updateCta(); });
  }

  function resetTransient() {
    product = null; selColor = null; selSize = null; selVariant = null; loading = false;
    if (elCta) { elCta.disabled = true; elCta.textContent = 'Select size'; elCta.classList.remove('is-ready', 'is-loading'); }
  }

  function close() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('ml-sheet-open');
    setTimeout(function () { sheet.hidden = true; }, 260);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.js-ml-quick-sheet');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      open(trigger.getAttribute('data-handle'));
      return;
    }
    if (!cache()) return;
    if (e.target.closest('[data-ml-sheet-close]') || e.target === overlay) { close(); return; }
    if (e.target.closest('.ml-sheet__cta')) { addToCart(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  window.MlQuickSheetAPI = { open: open, close: close };
})();
